export default {
    msisdn: "MSISDN",
    ratePlan: "Plan de tarifas",
    communicationPlan: "Plan de comunicación",
    dateActivated: "Fecha de activación",
    dateAdded: "Fecha de adición",
    dateUpdated: "Fecha de actualización",
    dateShipped: "Fecha de envío",
    operatorCustom1: "Operador Personalizado 1",
    operatorCustom2: "Operador Personalizado 2",
    operatorCustom3: "Operador Personalizado 3",
    operatorCustom4: "Operador Personalizado 4",
    operatorCustom5: "Operador Personalizado 5",
    accountCustom1: "Cuenta personalizada 1",
    accountCustom2: "Cuenta personalizada 2",
    accountCustom3: "Cuenta personalizada 3",
    accountCustom4: "Cuenta personalizada 4",
    accountCustom5: "Cuenta personalizada 5",
    accountCustom6: "Cuenta personalizada 6",
    accountCustom7: "Cuenta personalizada 7",
    accountCustom8: "Cuenta personalizada 8",
    accountCustom9: "Cuenta personalizada 9",
    accountCustom10: "Cuenta personalizada 10",
    customerCustom1: "Personalización del cliente 1",
    customerCustom2: "Personalización del cliente 2",
    customerCustom3: "Personalización del cliente 3",
    customerCustom4: "Personalización del cliente 4",
    customerCustom5: "Personalización del cliente 5",
    simNotes: "Notas de Sim",
    globalSimType: "Tipo global de Sim",
    mec: "MEC",
    customer: "Cliente",
    Msisdn: "MSISDN",
    Imei: "IMEI",
}